var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C8.828 10.5 9.5 9.828 9.5 9C9.5 8.172 8.828 7.5 8 7.5C7.172 7.5 6.5 8.172 6.5 9C6.5 9.828 7.172 10.5 8 10.5ZM18 19.5H6.561L13.566 13.655C13.812 13.446 14.258 13.447 14.499 13.654L19 17.494V18.5C19 19.052 18.552 19.5 18 19.5ZM6 5.5H18C18.552 5.5 19 5.948 19 6.5V14.864L15.797 12.132C14.807 11.29 13.258 11.29 12.277 12.126L5 18.198V6.5C5 5.948 5.448 5.5 6 5.5ZM18 3.5H6C4.346 3.5 3 4.846 3 6.5V18.5C3 20.154 4.346 21.5 6 21.5H18C19.654 21.5 21 20.154 21 18.5V6.5C21 4.846 19.654 3.5 18 3.5Z",
    fill: "#661C69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.5ad09aa4e3ec53114e147db272f3d936.svg";
export { ForwardRef as ReactComponent };